// extracted by mini-css-extract-plugin
export default {"cls1":"CitationModal-cls1__a0e7c2e5c49bad3a7e18","cls2":"CitationModal-cls2___14529319ad2a78f38dd CitationModal-cls1__a0e7c2e5c49bad3a7e18"};